import React from "react";
import "styles/components/forms/buttons/iconButton.css";

interface IconButtonProps {
  iconName: string;
  isEnable?: boolean;
  wrapperClass?: string;
  wrapperStyle?: React.CSSProperties;
  svgProp?: React.ImgHTMLAttributes<HTMLImageElement>; // note change
  onClickHandler?: () => void;
  id?: string;
}

const IconButton: React.FC<IconButtonProps> = ({
  onClickHandler,
  iconName,
  wrapperStyle = { display: "flex" },
  wrapperClass,
  svgProp = { width: 24, height: 24 },
  isEnable = true,
  id,
}) => {
  const iconSrc = `/assets/svg/common/${iconName}.svg`;

  return (
    <div className={wrapperClass} style={wrapperStyle}>
      <button
        id={id || iconName}
        aria-label={iconName}
        className="icon-button"
        onClick={onClickHandler}
        disabled={!isEnable}
        name={iconName}
        type="button"
      >
        <img
          src={iconSrc}
          alt={iconName}
          {...svgProp}
          style={{ pointerEvents: "none", ...(svgProp?.style || {}) }}
        />
      </button>
    </div>
  );
};

export default IconButton;
